import { EventActionTypes, MarketEventFlow } from "./types";

export const eventFlowUpdate = (payload: MarketEventFlow ): EventActionTypes => ({
  type: 'EVENT_FLOW_UPDATE',
  payload,
});

export const eventFlowError = (payload: string): EventActionTypes => ({
  type: 'EVENT_FLOW_ERROR',
  payload,
});

export const eventFlowHeartbeat = (payload: number | null): EventActionTypes => ({
  type: 'EVENT_FLOW_HEARTBEAT',
  payload
})